import { setting } from "shared/types/Report";
import { SettingCard, SettingTitle, SettingGroupWrap, SettingGroup, SettingLabelWrap, SettingLabel, SettingCheck, SettingSelect } from "../homeworkUi";

interface WordSettingProps{
    viewOptions:(name:string, max:number, unit:string) => any[],
    onSettingChangeHandler: <T>(type: keyof setting, name: string, value: T) => void,
    setting:setting
}

const WordSetting = ({viewOptions, setting, onSettingChangeHandler}:WordSettingProps) => {
    const TYPE = "word";
    return(
        <SettingCard>
            <SettingTitle>단어 학습</SettingTitle>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="focus" name="focus" checked={setting.word.focus} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, e.target.checked)}/>
                        <SettingLabel htmlFor="focus">단어집중학습</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="word_repeat" value={setting.word.word_repeat} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))} disabled={!setting.word.focus}>
                        {viewOptions("단어듣기", 4, "번")}
                    </SettingSelect>
                    <SettingSelect name="example_repeat" value={setting.word.example_repeat} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))} disabled={!setting.word.focus}>
                        {viewOptions("예문듣기", 4, "번")}
                    </SettingSelect>
                </SettingGroup>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="write" name="write" checked={setting.word.write} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, e.target.checked)}/>
                        <SettingLabel htmlFor="write">낱말 쓰기</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="word_write" value={setting.word.word_write} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))} disabled={!setting.word.write} >
                        {viewOptions("", 3, "단계")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="painting" name="painting" checked={setting.word.painting} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, e.target.checked)}/>
                        <SettingLabel htmlFor="painting">그림 맞추기</SettingLabel>
                    </SettingLabelWrap>
                </SettingGroup>
            </SettingGroupWrap>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabel>퀴즈 커트라인 (오답)</SettingLabel>
                    <SettingSelect name="cutline" value={setting.word.cutline} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))}>
                        {viewOptions("", 4, "개")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
        </SettingCard>
    )
}

export default WordSetting;
